import { useDispatch } from 'react-redux';

import { STATUS, searchPanelHide, searchPanelShow } from 'core/store';
import { useEqualSelector } from 'core/hooks';
import { Button } from './Button';
import { SearchBox } from './Search.styles';

function HeaderSearch(): JSX.Element {
  const dispatch = useDispatch();
  const searchPanelStatus = useEqualSelector(s => s.app.searchPanelStatus);

  const handleSearchBox = () => {
    dispatch(searchPanelStatus !== STATUS.IDLE ? searchPanelHide() : searchPanelShow());
  };

  return (
    <SearchBox className="search-box">
      <Button handleSearchBox={handleSearchBox}>
        {searchPanelStatus !== STATUS.IDLE ? 'Close search panel' : 'Search'}
      </Button>
    </SearchBox>
  );
}

export default HeaderSearch;
